import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import translations from '@modules/i18n';
import {sdoNs} from '@modules/constants-enumerate';

import {GroupLevelsFilter} from '@modules/group-levels-filter';

/**
 * @summary GroupSelector
 * @extends {AoflElement}
 */
@customElement('group-selector')
class GroupSelector extends i18nMixin(AoflElement) {
  @property({type: Object})
  groupInfo = {};

  @property({type: Number})
  level = 0;

  @property({type: Array})
  groups = [];

  @property({type: Number})
  maxLevel = 0;

  @property({type: Number})
  parentId = 0;

  @property({type: Boolean})
  showClasses = false;

  /**
   * @prop {GroupLevelsFilter}
   */
  groupLevelsFilter = null;


  constructor() {
    super();
    this.translations = translations;
    this.storeInstance = storeInstance;
  }
  /**
   * @readonly
   */
  static is = 'group-selector';

  async connectedCallback() {
    super.connectedCallback();

    const state = this.storeInstance.getState();
    const groupInfo = state[sdoNs.SESSION].group_info;
    const level = this.level;

    this.maxLevel = level;
    this.groupLevelsFilter = new GroupLevelsFilter(this.maxLevel, this.showClasses, true);

    let groups = await this.groupLevelsFilter.loadAllGroupsByParentPath(groupInfo);
    this.groups = this.filterForGroupsAboveLevel(groups);

    const path = this.groupInfo.path.slice(0, -1).split('.');
    path.shift();

    const realPath = path.map((part) => {
      return parseInt(part, 10);
    });
    this.realPath = realPath;

    groups = await this.groupLevelsFilter.loadSelectedGroups(realPath);

    this.groups = this.filterForGroupsAboveLevel(groups);

    const lastGroup = this.groups.at(-1);

    if (lastGroup?.selected > 0 || this.maxLevel <= groupInfo.level) {
      this.parentId = (this.maxLevel <= groupInfo.level) ? groupInfo.id : lastGroup.selected;

      this.dispatchEvent(new CustomEvent('data-updated', {
        composed: true,
        bubbles: true,
        detail: {
          parentId: this.parentId,
        }
      }));
    }

  }

  async selectGroup(e, groupIndex) {
    try {
      const itemIndex = e.target.value.trim();
      const selectedGroup = this.groups[groupIndex].groups[itemIndex];
      await this.updateGroupAndGetGroups(groupIndex, selectedGroup);
      this.parentId = selectedGroup.level === this.maxLevel ? selectedGroup.id : 0;

      // in this scenario we want to handle if a group only has one option in
      // it's dropdown and auto-populate the next dropdown. we don't want to
      // do this for the dashboard which is why we have this special logic here
      if (this.groups.length && this.groups[this.groups.length - 1]?.groups?.length === 1) {
        const lastGroup = this.groups[this.groups.length - 1].groups[0];
        await this.updateGroupAndGetGroups(groupIndex + 1, lastGroup);
        this.parentId = lastGroup.level === this.maxLevel ? lastGroup.id : 0;
      }

      this.dispatchEvent(new CustomEvent('data-updated', {
        composed: true,
        bubbles: true,
        detail: {
          parentId: this.parentId,
        }
      }));
    } catch (e) {
    }
  }

  filterForGroupsAboveLevel(groups) {
    const newGroups = [];
    groups.map((group) => {
      if (group.level < this.maxLevel) {
        newGroups.push(group);
      }
    });
    return newGroups;
  }

  async updateGroupAndGetGroups(groupIndex, selectedGroup) {
    let groups = await this.groupLevelsFilter.updateGroup(groupIndex, selectedGroup);
    this.groups = this.filterForGroupsAboveLevel(groups);
  }


  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default GroupSelector;
